import Loading from "@/components/Loading";
import AdminLayout from "@/layout/AdminLayout";
import React from "react";
import {PAGE_URL} from "../services/constant";
const NebulaPerfFeeAmortized = React.lazy(() =>
    import('../NebulaPerfFeeAmortized')
);
const nebulaPerfFeeAmortizedRoutesRegistry = [
    {
        path: PAGE_URL.NEBULA_PERF_FEE_AMORTIZED_PAGE,
        element: <NebulaPerfFeeAmortized />,
        loading: <Loading />,
        layout: AdminLayout,
    },
];

export default nebulaPerfFeeAmortizedRoutesRegistry;
